import { Flex, Modal, Typography } from "antd"
import { useSelector } from "react-redux"

const { Text } = Typography

export const CommentModal = ({ setModalType, invoiceComment }) => {
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleCloseModal = () => {
    setModalType(false)
  }

  return (
    <Modal
      open={true}
      centered={!isMobile}
      width={410}
      title={"Invoice comment"}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("global-wrap")}
    >
      <Flex vertical gap={10}>
        <Text type="secondary">Comment</Text>
        <Text strong>{invoiceComment}</Text>
      </Flex>
    </Modal>
  )
}
